import React, { useRef, useState, useEffect } from 'react'
import Slider from 'react-slick'
import { RealEstateDataPageComponentData, Review } from 'types'
import { Col, Container, Row } from 'react-bootstrap'

const settings = {
  autoplay: true,
  dots: false,
  infinite: true,
  speed: 500,
  items: 3,
  slidesToShow: 3,
  centerMode: true,
  centerPadding: `${screen.width / 10.5}px`,
  slidesToScroll: 3,
  rows: 1,
  slidesPerRow: 1,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        items: 3,
        slidesToShow: 3,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 992,
      settings: {
        items: 3,
        slidesToShow: 3,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        items: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}

const MOCKDATA: RealEstateDataPageComponentData = {
  title: 'Reviews de Google',
  // greviewsAutoplay: false,
  reviews: [
    {
      id: 1,
      link: "https://search.google.com/local/writereview?placeid=123FXS8-aposd091",
      image: "https://images.pexels.com/photos/2531553/pexels-photo-2531553.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      starts: [1,2,3,4],
      paragraph: "Laudantium enim quasi est quidem magnam voluptate ipsam eos tempora quo quasi aspernatur aut expedita occaecati aliquamnec enim quasi est quidem magnam voluptate essitat.",
      title: "Abhoy Latif"
    },
    {
      id: 2,
      image: "https://images.pexels.com/photos/4052800/pexels-photo-4052800.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      starts: [1,2,3,4,5],
      paragraph: "Quia molestiae enim quasi est quidem magnam voluptate reprehenderit quasi aspernatur aut expedita occaecati aliquam eveniet laudantium omnis quibusdam delectus.",
      title: "Spencer Selover"
    },
    {
      id: 3,
      link: "https://search.google.com/local/writereview?placeid=123FXS8-cvy2021",
      image: "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      starts: [1,2,3,4],
      paragraph: "With enim quasi est quidem magnam voluptate supporting text below quasi aspernatur aut expedita occaecati aliquamas a natural lead-in to additional content.",
      title: "Andrea Piacquadio"
    },
    {
      id: 4,
      link: "https://search.google.com/local/writereview?placeid=123ght-brown%CDE2021",
      starts: [1,2,3],
      paragraph: "Wquas enim quasi est quidem magnam voluptate accusantium unde quasi aspernatur aut expedita occaecati aliquam odit nobis qui voluptatem quia voluptas consequuntur itaque.",
      title: "Adrienn Matt"
    }
  ]
}

const GoogleReviews = (props: RealEstateDataPageComponentData) => {

  const { isDemo } = props
  const { title, reviews, greviewsAutoplay } = isDemo ? MOCKDATA : props
  settings.autoplay = (greviewsAutoplay !== undefined) ? Boolean(greviewsAutoplay) : true

  // Loader effect
  const [load, setLoad] = useState(true)
  useEffect(() => {
    setTimeout(() => {
      setLoad(() => false)
    }, 3000)
  }, [])
  
  const Review = require(`@components/cards-reviews/1`)?.default
  const sliderRef = useRef<any>()
  const showArrow = () => {
    return window.screen.width > 992
      ? reviews && reviews?.length > 3
        ? 'd-block'
        : 'd-none'
      : 'd-block'
  }

  const checkReviews = (reviews: any[]) => {
    return reviews?.length <= 2 ? reviews.concat(reviews[0]) : reviews
  }

  return (
    <section
      id="google-reviews"
      className={'gr p-y-config ' + (reviews?.length === 0 ? ' d-none' : '')}
    >
      <Container fluid>
        <Row>
          <Col xs={12}>
            <h2 className="section-title pb-lg-5">{title}</h2>
          </Col>
        </Row>
      </Container>
      <div className="reviews d-flex align-items-center justify-content-center my-4">
        {load ? (
          <Slider
            {...settings}
            lazyLoad="ondemand"
            className="overflow-hidden"
          >
            {[1, 2, 3, 4, 5, 6].map((index) => (
              <Review
                key={index}
                skeleton={true}
              />
            ))}
          </Slider>
        ) : null}
        {!load && reviews && reviews?.length > 0 ? (
          <>
            <Slider
              ref={sliderRef}
              {...settings}
              lazyLoad="ondemand"
              className="overflow-hidden"
            >
              {checkReviews(reviews)?.map((review: Review, index: number) => (
                <Review
                  key={index}
                  review={review}
                />
              ))}
            </Slider>
            <i
              className={'icon-arrow-left isArrowFeatured ' + showArrow()}
              onClick={() => sliderRef.current.slickPrev()}
            ></i>
            <i
              className={'icon-arrow isArrowFeatured ' + showArrow()}
              onClick={() => sliderRef.current.slickNext()}
            ></i>
          </>
        ) : null}
      </div>
    </section>
  )
}

export default GoogleReviews
